import { keyBy } from 'lodash';
import { useGetRetailerByClientQuery } from 'core/API/authApi';
import { useGetClientKeywordsByTypeQuery } from 'core/API/keywordsApi';
import { useGetListKeyQuery } from 'core/API/productsApi';
import { useGetCategoriesClientQuery, useGetCategoriesClientV2Query } from 'core/API/usersApi';
import { useEffect, useState } from 'react';

export const useRetailers = () => {
    const { data, isLoading, isError } = useGetRetailerByClientQuery();

    const [state, setState] = useState({
        retailers: data?.data,
        retailersById: keyBy(data?.data, 'id'),
        isLoading,
        isError,
    });

    useEffect(() => {
        setState({ retailers: data?.data, retailersById: keyBy(data?.data, 'id'), isLoading, isError });
    }, [isLoading, isError, data]);

    return state;
};

export const useKeywords = () => {
    const {
        data: keywordsOtherTypeData,
        isLoading,
        isError,
    } = useGetClientKeywordsByTypeQuery({
        type: 'search',
    });

    return { keywords: keywordsOtherTypeData?.keywords.map((ret) => ret.name).sort(), isLoading, isError };
};

export const useCategories = () => {
    const { data: categoriesData, isLoading, isError } = useGetCategoriesClientQuery();
    const categoriesSet = new Set();
    const categories = categoriesData?.categories_clients.reduce((acc: { id: number; name: string }[], ret) => {
        if (!categoriesSet.has(ret.level_1)) {
            categoriesSet.add(ret.level_1);
            acc.push({ id: Number(ret.level_1), name: ret.level_name_1 });
        }
        return acc;
    }, []);

    return { categories, isLoading, isError };
};

export const useSegments = () => {
    const { data: categoriesData, isLoading, isError } = useGetCategoriesClientQuery();

    const segments = categoriesData?.categories_clients.map((ret) => ({
        id: ret.level_3,
        name: `${ret.level_name_1} > ${ret.level_name_2} > ${ret.level_name_3}`,
    }));
    const semgentsMap: Record<string, any> = {};
    segments?.forEach((segment) => (semgentsMap[segment.id] = segment));

    return { segments: Object.values(semgentsMap), isLoading, isError };
};

export const useCats = () => {
    const { data: categoriesData, isLoading, isError } = useGetCategoriesClientQuery();

    return { cats: categoriesData?.categories_clients, isLoading, isError };
};

export const useListKey = (companyId: number) => {
    const {
        data: listKeyData,
        isLoading,
        isError,
    } = useGetListKeyQuery({
        retailer: 'default',
        lang: 'default',
        isRetailerAndLang: 'false',
        key: 'status',
        companyId,
    });

    return { list: listKeyData?.list, isLoading, isError };
};
